import { useState, useEffect } from 'react';
import { Client } from '../clientsData';

function getNextGroup(clients: Client[], currentIndex: number): Client[] {
  const groupSize = 3;
  const result: Client[] = [];
  for (let i = 0; i < groupSize; i++) {
    const index = (currentIndex + i) % clients.length;
    result.push(clients[index]);
  }
  return result;
}

export function useFadingClients(clients: Client[], duration: number) {
  const [visibleClients, setVisibleClients] = useState<Client[]>(clients.slice(0, 3));
  const [currentIndex, setCurrentIndex] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 3) % clients.length;
      setVisibleClients(getNextGroup(clients, nextIndex));
      setCurrentIndex(nextIndex);
    }, duration);

    return () => clearInterval(interval);
  }, [clients, duration, currentIndex]);

  return visibleClients;
}